/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:21
 * @LastEditTime: 2022-11-16 16:26:49
 * @FilePath: \web-app\src\network\other\pushLog.js
 * @Environment: Vue + Element
 * @Description: 推送日志
 */
import {
    request
} from '../request.js';

// 列表
export function pushLogList(data) {
    return request({
        url: '/web/back/sys/tweetLogUser/page',
        method: 'post',
        data
    })
}

// 搜索参数
export function reqSelectByType(data) {
    return request({
        url:'/web/back/sys/dict/selectByParentType',
        method: 'post',
        data
    })
}
